import { DeleteFeedModal } from "./DeleteFeedModal";
export default DeleteFeedModal;
